import PageLogin from "./PageLogin.vue";
const PageInviteAccept = () => import("../users/PageInviteAccept.vue");
import PageManagementDashboard from "./PageManagementDashboard.vue";
import PageChangePassword from "./PageChangePassword.vue";
import TwoFactorSetup from "./TwoFactorSetup.vue";
import TwoFactorVerification from "./TwoFactorVerification.vue";
import PageManagementSummary from "../dashboard/management_summary/PageManagementSummary.vue";
import PageManagementDashboardTrendReport from "./PageManagementDashboardTrendReport.vue";

const routes = {
  navigation: [
    {
      path: "/login",
      name: "Login",
      component: PageLogin,
      meta: { withoutAuth: true },
    },
    {
      path: "/",
      name: "ManagementDashboardIndex",
      component: PageManagementDashboard,
    },
    {
      path: "/management_dashboard",
      name: "ManagementDashboard",
      component: PageManagementDashboard,
    },
    {
      path: "/two-factor-setup",
      name: "TwoFactorSetup",
      component: TwoFactorSetup,
      props: (route) => {
        return {
          token: route.params.token,
          twoFactorSetupRequired: true,
        };
      },
      meta: { withoutAuth: true },
    },
    {
      path: "/two-factor-verification",
      name: "TwoFactorVerification",
      component: TwoFactorVerification,
      props: (route) => {
        return {
          token: route.params.token,
          twoFactorMethod: route.params.twoFactorMethod,
        };
      },
      meta: { withoutAuth: true },
    },
    {
      path: "/management_dashboard_trend_report",
      name: "ManagementDashboardTrendReport",
      component: PageManagementDashboardTrendReport,
    },
    {
      path: "/management_summary",
      name: "ManagementSummaryIndex",
      component: PageManagementSummary,
    },
    {
      path: "/change-password",
      name: "ChangePassword",
      component: PageChangePassword,
      meta: { withoutAuth: true },
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/invite/:token",
      name: "InviteAccept",
      component: PageInviteAccept,
      meta: { withoutAuth: true },
    },
  ],
};

export default routes;
